import { api, ServerResponse } from "./axios";
import { AxiosResponse } from "axios";
import { User } from "../redux/slices/user-slice";

export type RegisterUserParams = {
  username: string;
  password: string;
  email: string;
  firstName: string;
  lastName: string;
};

export type LoginUserParams = {
  username: string;
  password: string;
};

export const registerUser = (
  user: RegisterUserParams,
): Promise<AxiosResponse<ServerResponse<null>>> => {
  return api.post("/auth/register", user);
};

export const loginUser = (
  user: LoginUserParams,
): Promise<AxiosResponse<ServerResponse<null>>> => {
  return api.post("/auth/login", user);
};

export const logout = (): Promise<AxiosResponse<ServerResponse<null>>> => {
  return api.post("/auth/logout");
};

export const CURRENT_USER = "current-user";
export const currentUser = (): Promise<AxiosResponse<ServerResponse<User>>> => {
  return api.get("/auth/currentUser");
};
